import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue'
import Tournament from '../views/Tournament.vue'
import HHSChange from '../views/HHSChange.vue'
import Profile from '../views/Profile.vue'
import HCPIChange from '../views/HCPIChange.vue'
import Users from '../views/Users.vue'
import NewPassword from '../views/NewPassword.vue'
import store from '../main.js'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/hcpichange',
    name: 'HCPIChange',
    component: HCPIChange
  },
  {
    path: '/tournamentchange',
    name: 'TournamentChange',
    component: Tournament
  },
  {
    path: '/hhschange',
    name: 'HHSChange',
    component: HHSChange
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/resetPassword/:token',
    name: 'ResetPassword',
    component: NewPassword
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
